import React from 'react';
import { CheckIcon } from 'lucide-react';
export function ValueStackSection() {
  return <section className="py-6 px-4 bg-gray-900 text-white" data-id="element-198" data-mp="17nx8seosfmgu">
      <div className="max-w-3xl mx-auto bg-gray-800 rounded-3xl p-5 md:p-8 border-4 border-yellow-400 shadow-2xl" data-id="element-199" data-mp="17lb2eidmvd07">
        <h2 className="text-[20px] font-black mb-4 text-center text-[#EF5B4C] uppercase" data-id="element-200" data-mp="1me4kmbkai78k">
          Todo lo que vas a recibir hoy
        </h2>

        <div className="mb-4" data-id="element-201" data-mp="top6ve18q08y">
          <h3 className="text-2xl font-bold mb-3" data-id="element-202" data-mp="tnw7iy4m2d0u">📦 Acceso inmediato a:</h3>
          <ul className="space-y-2 text-xl pl-4" data-id="element-203" data-mp="opuogd76qdpd">
            <li className="flex items-center font-bold" data-id="element-204" data-mp="12oca85dj5g4n">
              <span className="text-yellow-400 mr-3" data-id="element-205" data-mp="12pvojqfmlh3s">•</span> Megapack ESI
              Primaria – Primer Ciclo completo
            </li>
            <li className="flex items-center font-bold" data-id="element-206" data-mp="2e3he3cpedkpu">
              <span className="text-yellow-400 mr-3" data-id="element-207" data-mp="2e1whzinfptpv">•</span> Megapack ESI
              Primaria – Segundo Ciclo completo
            </li>
            <li className="flex items-center" data-id="element-208" data-mp="1ncyujqztfgjr">
              <span className="text-yellow-400 mr-3" data-id="element-209" data-mp="1nc6xebqklard">•</span> Más de 250
              actividades listas para imprimir
            </li>
            <li className="flex items-center" data-id="element-210" data-mp="1se61jnu4wbpd">
              <span className="text-yellow-400 mr-3" data-id="element-211" data-mp="1wdewgw0wufmi">•</span> BONUS 1:
              Emergentes ESI
            </li>
            <li className="flex items-center" data-id="element-212" data-mp="21bgdzciou6vv">
              <span className="text-yellow-400 mr-3" data-id="element-213" data-mp="14mh45t2ggx1k">•</span> BONUS 2:
              Actividades Express ESI
            </li>
            <li className="flex items-center" data-id="element-214" data-mp="18nkkshsbux3u">
              <span className="text-yellow-400 mr-3" data-id="element-215" data-mp="18oc2cop3aub4">•</span> BONUS 3: Afiches
              ESI para el Aula
            </li>
            <li className="flex items-center" data-id="element-216" data-mp="1idvnk109z095">
              <span className="text-yellow-400 mr-3" data-id="element-217" data-mp="1iex8cx73f142">•</span> BONUS 4:
              Ciudadanía Digital para Primaria
            </li>
          </ul>
        </div>

        <div className="border-t border-gray-600 pt-4" data-id="element-218" data-mp="pxb7ocv05kxd">
          <h3 className="text-2xl font-bold mb-3" data-id="element-219" data-mp="pw00e32clv1i">Además vas a tener:</h3>
          <ul className="space-y-2 text-lg" data-id="element-220" data-mp="1t7goj4iyfv4f">
            <li className="flex items-start" data-id="element-221" data-mp="1t65jz2hoqjc9">
              <CheckIcon className="w-6 h-6 text-green-400 mr-3 flex-shrink-0 mt-1" data-id="element-222" data-mp="1oa6xxljtxdf0" />
              <span data-id="element-223" data-mp="221bsi98cbfih">Material listo para imprimir y usar</span>
            </li>
            <li className="flex items-start" data-id="element-224" data-mp="1xz70tg1gcsyh">
              <CheckIcon className="w-6 h-6 text-green-400 mr-3 flex-shrink-0 mt-1" data-id="element-225" data-mp="1y0i5rj6mw6r6" />
              <span data-id="element-226" data-mp="1aantp3u52m7z">Recursos para todo el año escolar</span>
            </li>
            <li className="flex items-start" data-id="element-227" data-mp="15at371e9zyng">
              <CheckIcon className="w-6 h-6 text-green-400 mr-3 flex-shrink-0 mt-1" data-id="element-228" data-mp="15c4854jgjcg5" />
              <span data-id="element-229" data-mp="1jb3vm8v8hlaq">Menos tiempo de planificación</span>
            </li>
            <li className="flex items-start" data-id="element-230" data-mp="1eapw5f7p7job">
              <CheckIcon className="w-6 h-6 text-green-400 mr-3 flex-shrink-0 mt-1" data-id="element-231" data-mp="1e9wli35mca0w" />
              <span data-id="element-232" data-mp="2unwjv9otfrm1">Más seguridad para trabajar ESI</span>
            </li>
            <li className="flex items-start" data-id="element-233" data-mp="2pr630k56srzk">
              <CheckIcon className="w-6 h-6 text-green-400 mr-3 flex-shrink-0 mt-1" data-id="element-234" data-mp="2psh9irq0odud" />
              <span data-id="element-235" data-mp="2y63s2gjuh46h">Actividades organizadas por temas</span>
            </li>
            <li className="flex items-start" data-id="element-236" data-mp="32a1p8lpm04ww">
              <CheckIcon className="w-6 h-6 text-green-400 mr-3 flex-shrink-0 mt-1" data-id="element-237" data-mp="326nqdng5mdu7" />
              <span data-id="element-238" data-mp="2obbvng200nda">Recursos visuales y claros</span>
            </li>
            <li className="flex items-start" data-id="element-239" data-mp="2t93ku2b9dvds">
              <CheckIcon className="w-6 h-6 text-green-400 mr-3 flex-shrink-0 mt-1" data-id="element-240" data-mp="3gxwlgc2tsreq" />
              <span data-id="element-241" data-mp="3gzzjnje4tquj">Herramientas para situaciones reales del aula</span>
            </li>
          </ul>
        </div>
      </div>
    </section>;
}